import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { BsFillPencilFill } from "react-icons/bs";

import { MDBDataTableV5, MDBCol } from "mdbreact";

import "react-datepicker/dist/react-datepicker.css";

import Notiflix from "notiflix";
import { Link } from "react-router-dom";
import PostApiCall from "../../Api";

import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

class ItemMaster extends Component {
  state = {
    ItemCode: "",
    ItemName: "",
    ItemUm: "",
    searchInput: "",
    itemSaved: false,
    status: "",
    itemData: [],
    array1: [],
    array2: [],
  };

  componentDidMount() {
    Notiflix.Loading.Init({
      svgColor: "#fa6e03",
    });

    Notiflix.Loading.Standard();
    this.fetchItem();

    Notiflix.Loading.Remove();
  }

  saveItem = () => {
    if (this.state.ItemCode !== "") {
      if (this.state.ItemName !== "") {
        if (this.state.ItemUm !== "") {
          if (this.state.status !== "") {
            this.onPost();
          } else {
            Notiflix.Notify.Failure("Please add status");
          }
        } else {
          Notiflix.Notify.Failure("Please add Unit of Measurement");
        }
      } else {
        Notiflix.Notify.Failure("Please add Item Name");
      }
    } else {
      Notiflix.Notify.Failure("Please add Item Code");
    }
  };

  onPost = () => {
    Notiflix.Loading.Dots("Please wait...");
    var login = localStorage.getItem("LoginDetail");
    var details = JSON.parse(login);
    PostApiCall.postRequest(
      {
        itemid: null,
        itemcode: this.state.ItemCode,
        itemname: this.state.ItemName,
        uom: this.state.ItemUm,
        status: this.state.status,
      },
      "additem"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Success("Data is successfully updated.");
          this.fetchItem();
          this.setState({
            ItemCode: "",
            ItemName: "",
            ItemUm: "",
            status: "",
          });
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Failure(obj.data);
        }
      })
    );
  };


  
  fetchItem() {
    Notiflix.Loading.Dots("Please wait...");
    PostApiCall.postRequest(
      {
        WhereClause: "",
      },
      "getitemmaster"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          this.setState({
            itemData: obj.data,
          });
          this.setState({
            array1: this.state.itemData.slice(0, 4),
          });
          this.setState({
            array2: this.state.itemData.slice(4),
          });
          console.log(this.state.array2);
          Notiflix.Loading.Remove();
        }
      })
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Modal
              open={this.state.open}
              onClose={() => {
                this.setState({ open: false });
              }}
              center
            >
              <div class="modal-content modelcontent3">
                <div
                  class="modal-header gtrendz-bg-soft-pink"
                  style={{ background: "rgb(13, 12, 12)" }}
                >
                  <h4 class="modal-title text-white">Update Status</h4>
                </div>

                <div class="modal-footer">
                  <button
                    className="btn align-items-center gtrendz-btn"
                    type="submit"
                    style={{ float: "right" }}
                    onClick={() => {
                      this.setState({
                        open: false,
                        Status: "Active",
                      });
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </Modal>

            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={"Kalanjiam Hardware"}
              breadcrumbItem={"Item List"}
            />
            <Row>
              <Col xl="12">
                <Card className="overflow-hidden">
                  <div
                    className="gtrendz-bg-soft-pink"
                    style={{ background: "rgb(13, 12, 12)" }}
                  >
                    <Row>
                      <Col xs="6">
                        <div className="gtrendz-text p-3">
                          <h5 className="gtrendz-text text-white">
                            Item Master
                          </h5>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <Card className="overflow-hidden">
                    <CardBody className="pt-0">
                      <Row></Row>
                    </CardBody>
                    <CardBody className="pt-0">
                      <Row>
                        <Col xs="12">
                          <MDBCol md="3" style={{ marginBottom: "10px" }}>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Search"
                              aria-label="Search"
                              onChange={(e) =>
                                this.setState({ searchInput: e.target.value })
                              }
                              value={this.state.searchInput}
                            />
                          </MDBCol>
                        </Col>
                        <div className="grid-column">
                          <div style={{ width: "90%", margin: "0 auto" }}>
                            {" "}
                            <Card
                              color="light"
                              style={{ padding: "1.5rem", marginTop: "20px" }}
                            >
                              <CardBody style={{ paddingTop: "0px" }}>
                                <div>
                                  <label>
                                    Item Code{" "}
                                    <span style={{ color: "red" }}> *</span>
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.ItemCode}
                                    onChange={(text) => {
                                      this.setState({
                                        ItemCode: text.target.value,
                                      });
                                    }}
                                  ></input>
                                </div>
                                <div>
                                  <label>
                                    Item Name{" "}
                                    <span style={{ color: "red" }}> *</span>
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.ItemName}
                                    onChange={(text) => {
                                      this.setState({
                                        ItemName: text.target.value,
                                      });
                                    }}
                                  ></input>
                                </div>
                                <div>
                                  <label>
                                    Unit Of Measurement{" "}
                                    <span style={{ color: "red" }}> *</span>
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.ItemUm}
                                    onChange={(text) => {
                                      this.setState({
                                        ItemUm: text.target.value,
                                      });
                                    }}
                                  ></input>
                                </div>
                                <Row>
                                  <Col>
                                    <a
                                      type="submit"
                                      className="btn align-items-center btn cloud-dhobi-btn"
                                      style={{
                                        display: "block",
                                        marginTop: "25px",
                                      }}
                                      onClick={(e) => {
                                        this.saveItem();
                                      }}
                                    >
                                      Save
                                    </a>
                                  </Col>
                                  <Col>
                                    <form
                                      style={{
                                        textAlign: "center",
                                        marginTop: "15px",
                                      }}
                                    >
                                      <h5>Status</h5>
                                      <label style={{ marginRight: "5px" }}>
                                        active
                                      </label>
                                      <input
                                        type="radio"
                                        id="active"
                                        name="active"
                                        value={this.state.status}
                                        placeholder="Active"
                                        style={{ marginRight: "20px" }}
                                        onClick={() => {
                                          this.setState({
                                            status: "active",
                                          });
                                          console.log(this.state.status);
                                        }}
                                      ></input>
                                      <label style={{ marginRight: "5px" }}>
                                        Inactive
                                      </label>
                                      <input
                                        type="radio"
                                        id="active"
                                        name="active"
                                        value={this.state.status}
                                        placeholder="Inactive"
                                        onClick={() => {
                                          this.setState({
                                            status: "inactive",
                                          });
                                          console.log(this.state.status);
                                        }}
                                      ></input>
                                    </form>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </div>
                          <div>
                            <div className="item-grid">
                              {this.state.array1.map((item, index) => {
                                const {
                                  fld_item_code,
                                  fld_item_name,
                                  fld_status,
                                  fld_uom,
                                } = item;
                                console.log(item);
                                return (
                                  <div style={{ width: "90" }}>
                                    <Card
                                      color="light"
                                      key={index}
                                      style={{
                                        marginTop: "20px",
                                        height: "144px",
                                        width: "90%",
                                      }}
                                    >
                                      <CardBody>
                                        <BsFillPencilFill
                                          style={{
                                            position: "absolute",
                                            color: "black",
                                            fontSize: "1.3rem",
                                            left: "90%",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {}}
                                        />
                                        <div>
                                          <h5 className="font-h5">
                                            {" "}
                                            <strong>Item Code</strong> :
                                            {fld_item_code}
                                          </h5>
                                        </div>
                                        <div>
                                          <h5 className="font-h5">
                                            <strong>Item Name</strong> :
                                            {fld_item_name}
                                          </h5>
                                        </div>
                                        <div>
                                          <h5 className="font-h5">
                                            <strong>Unit Of Measurement</strong>
                                            :{fld_uom}
                                          </h5>
                                        </div>
                                        <div>
                                          <h5 className="font-h5">
                                            <strong>Status</strong>:{fld_status}
                                          </h5>
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                        <div className="main-grid-column">
                          {this.state.array2.map((item, index) => {
                            const {
                              fld_item_code,
                              fld_item_name,
                              fld_status,
                              fld_uom,
                            } = item;
                            console.log(item);
                            return (
                              <div>
                                <Card
                                  color="light"
                                  key={index}
                                  style={{
                                    marginTop: "20px",
                                    height: "144px",
                                    width: "90%",
                                  }}
                                >
                                  <CardBody>
                                    <BsFillPencilFill
                                      style={{
                                        position: "absolute",
                                        color: "black",
                                        fontSize: "1.3rem",
                                        left: "90%",
                                        cursor: "pointer",
                                      }}
                                    />
                                    <div>
                                      <h5 className="font-h5">
                                        {" "}
                                        <strong>Item Code</strong> :
                                        {fld_item_code}
                                      </h5>
                                    </div>
                                    <div>
                                      <h5 className="font-h5">
                                        <strong>Item Name</strong> :
                                        {fld_item_name}
                                      </h5>
                                    </div>
                                    <div>
                                      <h5 className="font-h5">
                                        <strong>Unit Of Measurement</strong>:
                                        {fld_uom}
                                      </h5>
                                    </div>
                                    <div>
                                      <h5 className="font-h5">
                                        <strong>Status</strong>:{fld_status}
                                      </h5>
                                    </div>
                                  </CardBody>
                                </Card>
                              </div>
                            );
                          })}
                        </div>
                      </Row>
                    </CardBody>
                  </Card>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default ItemMaster;
